import { useEffect } from "react";
import type { Me } from "./types";

export type Theme = "dark" | "light";

/** Applies a theme now and remembers it in this browser (the login page uses it before sign-in). */
export function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem("crm-theme", theme);
  } catch {
    /* private mode: the user's saved preference still applies after sign-in */
  }
}

/** Keeps the page in the signed-in user's saved theme (dark unless they chose light). */
export function useUserTheme(me: Me | null | undefined) {
  const theme: Theme = me?.preferences?.theme === "light" ? "light" : "dark";
  useEffect(() => {
    if (me) applyTheme(theme);
  }, [me, theme]);
  return theme;
}
